/* eslint-disable no-unused-vars */
import { Buttons, ChangeColumnsPopUp } from 'components';
import { ColumnsIcon } from 'assets/icons';
import { useSignal, useComputed } from '@preact/signals-react';

const btnCustomOpen = {
  color: 'rgb(59, 137, 246)', // primary_500
};

export const ColumnsBtn = () => {
  const isOpen$ = useSignal(false);

  return (
    <div>
      <Buttons.QuaternaryNormal
        id='chooseFiltersBtn'
        icon={<ColumnsIcon />}
        isPressed={isOpen$.value}
        style={isOpen$.value ? btnCustomOpen : {}}
        onClick={() => (isOpen$.value = true)}
      >
        Columns
      </Buttons.QuaternaryNormal>
      {useComputed(
        () => isOpen$.value && <ChangeColumnsPopUp isOpen$={isOpen$} title='Table Columns' />,
      )}
    </div>
  );
};
